import axios from '../axios'

const getListStudentEventsApi = async (studentId, startTime, endTime) => {
    return await axios.get(`api/teacher/students/${studentId}/events`, { params: { startTime, endTime } })
}

export default getListStudentEventsApi
